import { createRoot, type Root } from 'react-dom/client';
import { Tooltip } from 'antd';
import { CompassWidget as DeckCompassWidget } from '@deck.gl/widgets';

class CompassWidget extends DeckCompassWidget {
  root: Root | null = null;

  public onAdd(): HTMLDivElement {
    const rootElement = this.onCreateRootElement();
    this.root = createRoot(rootElement);
    return rootElement;
  }

  public onRemove(): void {
    this.root?.unmount();
    this.root = null;
  }

  public onRenderHTML(): void {
    const viewId = this.viewId || Object.values(this.viewports)[0]?.id;
    const [rz, rx] = this.getRotation(
      viewId ? this.viewports[viewId] : undefined
    );

    this.root?.render(
      <div className="deck-widget-button" style={{ perspective: 100 }}>
        <Tooltip placement="top" title={this.props.label}>
          <button
            type="button"
            aria-label={this.props.label}
            style={{ transform: `rotateX(${rx}deg)` }}
            onClick={(): void => {
              for (const viewport of Object.values(this.viewports)) {
                this.handleCompassReset(viewport);
              }
            }}
          >
            <svg fill="none" width="100%" height="100%" viewBox="0 0 26 26">
              <g transform={`rotate(${rz},13,13)`}>
                <path
                  d="M10 13.0001L12.9999 5L15.9997 13.0001H10Z"
                  fill="var(--icon-compass-north-color, rgb(240, 92, 68))"
                />
                <path
                  d="M16.0002 12.9999L13.0004 21L10.0005 12.9999H16.0002Z"
                  fill="var(--icon-compass-south-color, rgb(204, 204, 204))"
                />
              </g>
            </svg>
          </button>
        </Tooltip>
      </div>
    );
  }
}

export { CompassWidget };
